import { useTheme } from "@hooks";

export const Minus = () => {
  const { theme } = useTheme();

  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="17.5"
        cy="17.182"
        r="17"
        fill={theme.chart.projection.default.adjuster.background}
      />
      <path
        d="M20.4475 16.3568V18.2616H14.5541V16.3568H20.4475Z"
        fill={theme.chart.projection.default.adjuster.fill}
      />
    </svg>
  );
};
